module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-profile-602428d86a1545a859bdb61614abb34f.svg";